if (!customElements.get('mj-hero-slider')) {
  customElements.define(
    'mj-hero-slider',
    class MjHeroSlider extends HTMLElement {
      connectedCallback() {
        this.slides = Array.from(this.querySelectorAll('.mj-hero__slide'));
        this.dots = Array.from(this.querySelectorAll('.mj-hero__dot'));
        this.counter = this.querySelector('.mj-hero__current');
        this.pauseButton = this.querySelector('.mj-hero__pause');
        this.index = 0;
        this.userPaused = false;
        if (this.slides.length < 2) return;

        this.querySelectorAll('.mj-hero__arrow').forEach((button) =>
          button.addEventListener('click', () => this.go(this.index + Number(button.dataset.dir)))
        );
        this.dots.forEach((dot) => dot.addEventListener('click', () => this.go(Number(dot.dataset.index))));
        this.pauseButton?.addEventListener('click', () => this.togglePause());

        // Swipe on touch screens; autoplay carries on afterwards.
        this.addEventListener('touchstart', (e) => (this.touchX = e.touches[0].clientX), { passive: true });
        this.addEventListener(
          'touchend',
          (e) => {
            const dx = e.changedTouches[0].clientX - this.touchX;
            if (Math.abs(dx) > 40) this.go(this.index + (dx < 0 ? 1 : -1));
          },
          { passive: true }
        );

        // Pause only for keyboard users moving focus inside the slider.
        this.addEventListener('focusin', (e) => {
          if (e.target.matches(':focus-visible')) this.stop();
        });
        this.addEventListener('focusout', () => this.start());

        // Don't rotate while the tab is hidden or the hero is scrolled away.
        document.addEventListener('visibilitychange', () => (document.hidden ? this.stop() : this.start()));
        new IntersectionObserver(([entry]) => (entry.isIntersecting ? this.start() : this.stop())).observe(this);

        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) this.setPaused(true);
        this.start();
      }

      disconnectedCallback() {
        this.stop();
      }

      go(index) {
        this.index = (index + this.slides.length) % this.slides.length;
        this.slides.forEach((slide, i) => {
          const active = i === this.index;
          slide.classList.toggle('is-active', active);
          slide.toggleAttribute('inert', !active);
          if (active) slide.removeAttribute('aria-hidden');
          else slide.setAttribute('aria-hidden', 'true');
        });
        this.dots.forEach((dot, i) => dot.setAttribute('aria-current', i === this.index ? 'true' : 'false'));
        if (this.counter) this.counter.textContent = String(this.index + 1).padStart(2, '0');
        // Restart the timer so the progress bar and the slide change stay in step.
        this.start();
      }

      start() {
        this.stop();
        if (this.dataset.autoplay !== 'true' || this.userPaused) return;
        this.timer = window.setTimeout(() => this.go(this.index + 1), Number(this.dataset.speed) || 6000);
      }

      stop() {
        window.clearTimeout(this.timer);
      }

      togglePause() {
        this.setPaused(!this.userPaused);
        this.userPaused ? this.stop() : this.start();
      }

      setPaused(paused) {
        this.userPaused = paused;
        this.classList.toggle('is-paused', paused);
        if (!this.pauseButton) return;
        this.pauseButton.setAttribute('aria-pressed', String(paused));
        this.pauseButton.setAttribute('aria-label', paused ? 'Play slideshow' : 'Pause slideshow');
        this.pauseButton.firstElementChild.textContent = paused ? '▶' : 'II';
      }
    }
  );
}
